/* tslint:disable */

/**
 */
export class HeadBalanceMaxResult {
    vep?: number;
    id?: number;
    equipName?: string;
    calculWarning?: number;
    tr?: number;
    ts?: number;
    vc?: number;
    specificSize?: string;
    tfp?: number;
    dhp?: number;
    conso?: string;
    conso_warning?: string;
    toc?: string;
    precision?: number;
    background?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/head-balance-max-result.ts